import {TEMPLATE_ID_HEADER} from '../../utils/constants';

export const SET_FAMILY_FRIENDLY = 'SET_FAMILY_FRIENDLY';

// actions
function setFamilyFriendly(payload) {
    return {
        type: SET_FAMILY_FRIENDLY,
        payload,
    };
}

export function fetchFamilyFriendly({
    basePathPrefix,
    destinationLbsId,
    destinationName,
}) {
    return (refinementKey = null) => {
        return (dispatch, getState) => {
            const {
                config: {template},
                familyFriendly: {listings = {}},
            } = getState();

            if (listings && listings[refinementKey]) {
                dispatch(
                    setFamilyFriendly({
                        refinementKey,
                        listings: listings[refinementKey],
                    })
                );
                return null;
            }

            const refinement = refinementKey
                ? `&refinementKey=${refinementKey}`
                : '';
            const pathName = `${basePathPrefix}/api/family-friendly?lbsId=${destinationLbsId}&destinationName=${destinationName}${refinement}`;

            return fetch(pathName, {
                credentials: 'same-origin',
                headers: {
                    [TEMPLATE_ID_HEADER]: template,
                },
            })
                .then((res) => {
                    if (!res.ok) {
                        throw new Error('Failed loading family-friendly');
                    }
                    return res.json();
                })
                .then((payload) => {
                    dispatch(setFamilyFriendly(payload));
                })
                .catch((err) => console.error(err)); // eslint-disable-line no-console
        };
    };
}

// reducers
export default function familyFriendly(state = {}, action) {
    switch (action.type) {
        case SET_FAMILY_FRIENDLY:
            const filters = state.filters || action.payload.filters;
            const listings = state.listings || {};
            listings[action.payload.refinementKey] = action.payload.listings;

            return {
                ...state,
                ...action.payload,
                filters,
                listings,
            };

        default:
            return state;
    }
}
